// @ts-ignore
import type * as SchemaTypes from '../../../../../../graphql/api/index';

import { gql } from 'graphql-tag';
export const QuestionnaireConditionNotIsEqualToFragmentDoc = gql`
    fragment questionnaireConditionNotIsEqualTo on QuestionnaireConditionNotIsEqualTo {
  __typename
  question {
    id
  }
  valueString: value
}
    `;